module.exports = __webpack_public_path__ + "static/img/placeSuccess.e05c3f48.png";